export * from '@fhs/routing/src/routes/(tabs)/rewards/history';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/history';
